
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },
  head() {
    return {
      title: "Plongez dans les coulisses d’une agence de communication",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Pour se faire connaître auprès de ses clients, propulser la croissance de son activité et accroître son chiffre d’affaires, un professionnel doit faire équipe avec une agence de communication comme ALEO",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Plongez dans les coulisses d’une agence de communication",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Pour se faire connaître auprès de ses clients, propulser la croissance de son activité et accroître son chiffre d’affaires, un professionnel doit faire équipe avec une agence de communication comme ALEO",
        },
      ],
    };
  },
};
